import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer_main">
      <div className="footer">
        <div className="container-xl">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 mb-sm-0 mt-3">
              <div className="footer_logo">
                <Link to="/">
                  <img
                    className="img-fluid"
                    src="/assets/images/logo-removebg-preview.png"
                    alt=""
                  />
                </Link>
              </div>

              <div className="footer_menu_item1 mt-4">
                <ul>
                  <li className="footer_menu_item1_menu">
                    <i class="fa-solid fa-location-dot me-2 color-brand-1"></i>
                    <a href="#">Nairobi - Kenya</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <i class="fa-solid fa-phone-volume me-2 color-brand-1"></i>
                    <a href="tel:+254794397129">+254794397129</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <i class="fa-solid fa-envelope me-2 color-brand-1"></i>
                    <a href="mailto:info@bebamzigo.com">info@bebamzigo.com</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3">
              <div className="footer_menu_item1">
                <ul>
                  <li className="footer_menu_item1_head mb-3">
                    <a href="#">Support</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/about-us">About Us</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/vision-mission">Vision &amp; Mission</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/blog">Blogs</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/careers">Careers</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/#contact-us">Contact Us</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/login">Ship Now</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3">
              <div className="footer_menu_item1">
                <ul>
                  <li className="footer_menu_item1_head mb-3">
                    <a href="#">Policies</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/terms-of-services">Terms of service</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/Privacy">Privacy</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/DriverPrivacy">Driver Privacy</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/ShipperTerms">Shipper terms</a>
                  </li>
                  <li className="footer_menu_item1_menu">
                    <a href="/TransporterTerms">Transporter terms</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3 mt-3">
              <div className="social-media">
                <span>Follow Us On</span>
                <div className="mt-2 pt-1">
                  <div className="social-links-div-footer d-flex flex-wrap gap-3">
                    <a href="https://www.facebook.com/profile.php?id=61559655251381">
                      <i class="fa-brands fa-facebook-f"></i>
                    </a>
                    <a href="https://x.com/Bebamzigoltd">
                      <i class="fa-brands fa-x"></i>
                    </a>
                    <a href="https://www.youtube.com/@bebamzigoafrica3642">
                      <i class="fa-brands fa-youtube"></i>
                    </a>
                    <a href="https://www.instagram.com/bebamzigo_official/">
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a href="https://www.tiktok.com/@bebamzigo.ke0?_r=1&_t=ZS-94cYRHqXghd">
                      <i class="fa-brands fa-tiktok"></i>
                    </a>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
